window.addEventListener('load', () => {
  const isLocalPreview = ['localhost', '127.0.0.1'].includes(window.location.hostname);

  if (sessionStorage.getItem("ls-address") === null && !window.Shopify.designMode && !isLocalPreview) {
    return window.location.href = "/";
  }

  const form = document.querySelector("#ls-choose-grass-type__form");

  if (!form) return;

  form.addEventListener("submit", function (evt) {
    evt.preventDefault();

    this.querySelector(".ls-choose-grass-type__next-button > span").classList.add('visibility-hidden');
    this.querySelector(".ls-choose-grass-type__next-button .loading-overlay__spinner").classList.remove('hidden');

    const data = new FormData(this);
    const entries = Object.fromEntries(data.entries());

    if (!entries.grassType) {
      this.querySelector(".ls-choose-grass-type__next-button > span").classList.remove('visibility-hidden');
      this.querySelector(".ls-choose-grass-type__next-button .loading-overlay__spinner").classList.add('hidden');
      alert("Please make a selection.");
      return;
    }

    sessionStorage.setItem('ls-grass-type', entries.grassType);
    return window.location.href = "/pages/select-program";
  });

  // per request, move to next page on grass type select
  form.querySelectorAll("input[name='grassType']").forEach(radio => {
    radio.addEventListener('click', () => {
      form.querySelector(".ls-choose-grass-type__next-button").click();
    });
  });
});
